import { render, staticRenderFns } from "./ProvisionalApproval.vue?vue&type=template&id=d751c4a6&scoped=true"
import script from "./ProvisionalApproval.vue?vue&type=script&lang=js"
export * from "./ProvisionalApproval.vue?vue&type=script&lang=js"
import style0 from "./ProvisionalApproval.vue?vue&type=style&index=0&id=d751c4a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d751c4a6",
  null
  
)

export default component.exports